import logoIcon from "./logo-ecostern-icon.png";

type Props = React.ComponentProps<"img">;

export const LogoIcon = (props: Props) => {
    return <img src={logoIcon} {...props} />;
};
